import { TOGGLE_SIDEBAR_OPEN } from './constants';

export const toggleSidebarOpen = () => ({
  type: TOGGLE_SIDEBAR_OPEN,
});
